(() => {
  const activate = () => {
    const lander = document.querySelector('[data-nc-lander]');
    if (!lander) return;
    document.documentElement.classList.add('nc-landing-active');
    document.body.classList.add('nc-landing-active');
    if (lander.hasAttribute('data-hide-theme-chrome')) {
      document.documentElement.classList.add('nc-hide-theme-chrome');
      document.body.classList.add('nc-hide-theme-chrome');
    }

    const stickyBuy = document.querySelector('[data-nc-sticky-buy]');
    const offer = document.querySelector('#nc-performance-offer');
    const buybox = document.querySelector('#nc-performance-buybox') || offer;
    document.querySelectorAll('a[href="#nc-performance-offer"]').forEach((link) => {
      link.setAttribute('href', '#nc-performance-buybox');
      if (link.textContent.trim() === 'Choose your plan') link.textContent = 'Shop Now';
    });

    const connectLiveSubscriptionPrice = () => {
      if (!offer || offer.dataset.ncPriceConnected) return;
      const source = offer.querySelector('[data-rtx-sub-price], .rtx-sas-price');
      const compareSource = offer.querySelector('.rtx-sas-compare');
      const targets = document.querySelectorAll('[data-nc-live-subscription-price]');
      if (!source || !targets.length) return;

      const compareTargets = document.querySelectorAll('[data-nc-live-subscription-compare-price]');
      offer.dataset.ncPriceConnected = 'true';

      const syncPrice = () => {
        const price = source.textContent.trim();
        if (price) targets.forEach((target) => { target.textContent = price; });

        if (compareSource && compareTargets.length) {
          const comparePrice = compareSource.textContent.trim();
          compareTargets.forEach((target) => {
            target.textContent = comparePrice;
            target.hidden = !comparePrice;
          });
        }
      };

      syncPrice();
      const priceObserver = new MutationObserver(syncPrice);
      priceObserver.observe(source, {
        childList: true,
        characterData: true,
        subtree: true,
      });
      if (compareSource) {
        priceObserver.observe(compareSource, {
          childList: true,
          characterData: true,
          subtree: true,
        });
      }
      offer.addEventListener('change', () => requestAnimationFrame(syncPrice));
      offer.addEventListener('click', () => setTimeout(syncPrice, 0));
    };
    connectLiveSubscriptionPrice();
    if (stickyBuy && offer && !stickyBuy.dataset.initialized) {
      stickyBuy.dataset.initialized = 'true';
      stickyBuy.hidden = false;
      const observer = new IntersectionObserver(([entry]) => {
        stickyBuy.classList.toggle('is-visible', !entry.isIntersecting);
      }, { threshold: 0.15 });
      observer.observe(offer);

      const stickySubmit = stickyBuy.querySelector('[data-nc-sticky-submit]');
      if (stickySubmit) {
        stickySubmit.addEventListener('click', () => {
          const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          buybox.scrollIntoView({
            behavior: reducedMotion ? 'auto' : 'smooth',
            block: 'start',
          });
        });
      }
    }

    document.querySelectorAll('[data-nc-product-gallery]').forEach((gallery) => {
      if (gallery.dataset.initialized) return;
      const mainImage = gallery.querySelector('.nc-media-frame img');
      const viewport = gallery.querySelector('[data-nc-gallery-viewport]');
      const previous = gallery.querySelector('[data-nc-gallery-prev]');
      const next = gallery.querySelector('[data-nc-gallery-next]');
      const thumbnails = gallery.querySelectorAll('[data-nc-gallery-thumb]');
      if (!mainImage || !viewport || !thumbnails.length) return;
      gallery.dataset.initialized = 'true';

      const updateControls = () => {
        const maxScroll = viewport.scrollWidth - viewport.clientWidth;
        if (previous) previous.disabled = viewport.scrollLeft <= 2;
        if (next) next.disabled = viewport.scrollLeft >= maxScroll - 2;
      };
      const move = (direction) => {
        viewport.scrollBy({ left: viewport.clientWidth * 0.82 * direction, behavior: 'smooth' });
      };

      if (previous) previous.addEventListener('click', () => move(-1));
      if (next) next.addEventListener('click', () => move(1));
      viewport.addEventListener('scroll', updateControls, { passive: true });
      viewport.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') { event.preventDefault(); move(-1); }
        if (event.key === 'ArrowRight') { event.preventDefault(); move(1); }
      });

      thumbnails.forEach((thumbnail) => {
        thumbnail.addEventListener('click', () => {
          const source = thumbnail.dataset.ncGallerySrc;
          if (!source) return;
          mainImage.removeAttribute('srcset');
          mainImage.removeAttribute('sizes');
          mainImage.src = source;
          mainImage.alt = thumbnail.dataset.ncGalleryAlt || mainImage.alt;
          thumbnails.forEach((item) => {
            const active = item === thumbnail;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-pressed', active ? 'true' : 'false');
          });
          thumbnail.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
        });
      });

      updateControls();
      window.addEventListener('resize', updateControls, { passive: true });
    });

    document.querySelectorAll('[data-nc-ingredient-carousel]').forEach((carousel) => {
      if (carousel.dataset.initialized) return;
      const viewport = carousel.querySelector('[data-nc-ingredient-viewport]');
      const previous = carousel.querySelector('[data-nc-ingredient-prev]');
      const next = carousel.querySelector('[data-nc-ingredient-next]');
      if (!viewport || !previous || !next) return;
      carousel.dataset.initialized = 'true';

      const move = (direction) => {
        const atStart = viewport.scrollLeft <= 2;
        const atEnd = viewport.scrollLeft + viewport.clientWidth >= viewport.scrollWidth - 2;
        let left = viewport.scrollLeft + viewport.clientWidth * direction;
        if (direction > 0 && atEnd) left = 0;
        if (direction < 0 && atStart) left = viewport.scrollWidth - viewport.clientWidth;
        viewport.scrollTo({ left, behavior: 'smooth' });
      };

      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      viewport.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') { event.preventDefault(); move(-1); }
        if (event.key === 'ArrowRight') { event.preventDefault(); move(1); }
      });

      const cards = Array.from(carousel.querySelectorAll('.nc-ingredient-card'));
      const fitSharedTypeScale = () => {
        const mobile = window.matchMedia('(max-width: 900px)').matches;
        let titleSize = mobile ? 22 : 20;
        let copySize = 13;
        const minimumTitleSize = 12;
        const minimumCopySize = 9;

        const applyScale = () => {
          carousel.style.setProperty('--nc-ingredient-title-size', `${titleSize}px`);
          carousel.style.setProperty('--nc-ingredient-copy-size', `${copySize}px`);
        };
        const hasOverflow = () => cards.some((card) => card.scrollHeight > card.clientHeight + 1);

        applyScale();
        while (hasOverflow() && (titleSize > minimumTitleSize || copySize > minimumCopySize)) {
          titleSize = Math.max(minimumTitleSize, titleSize - 0.5);
          copySize = Math.max(minimumCopySize, copySize - 0.25);
          applyScale();
        }

        carousel.dataset.ingredientTitleSize = titleSize;
        carousel.dataset.ingredientCopySize = copySize;
      };

      let fitFrame;
      const scheduleFit = () => {
        cancelAnimationFrame(fitFrame);
        fitFrame = requestAnimationFrame(fitSharedTypeScale);
      };
      scheduleFit();
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(scheduleFit);
      window.addEventListener('resize', scheduleFit, { passive: true });
    });

    const minimalHeader = document.querySelector('[data-nc-minimal-header]');
    if (minimalHeader && !document.querySelector('[data-nc-production-light]') && !minimalHeader.dataset.initialized) {
      minimalHeader.dataset.initialized = 'true';
      const syncHeader = () => minimalHeader.classList.toggle('is-visible', window.scrollY > 140);
      syncHeader();
      window.addEventListener('scroll', syncHeader, { passive: true });
    }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', activate);
  else activate();

  document.addEventListener('shopify:section:load', activate);
})();
